
import { Button } from "@/components/ui/button";
import { Heart } from 'lucide-react';

interface LocalFavoritesCollapsedStateProps {
  favoritesCount: number;
  onExpand: () => void;
}

export const LocalFavoritesCollapsedState = ({ 
  favoritesCount, 
  onExpand 
}: LocalFavoritesCollapsedStateProps) => {
  return (
    <div className="container mx-auto px-4 mb-8">
      <div className="bg-gradient-to-r from-red-50 to-pink-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Heart className="h-5 w-5 text-red-500 fill-current" />
            <span className="text-red-700 font-medium">
              Je hebt {favoritesCount} favoriete {favoritesCount === 1 ? 'vakantie' : 'vakanties'}
            </span>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={onExpand}
            className="text-red-600 border-red-300 hover:bg-red-50"
          >
            Toon favorieten
          </Button>
        </div>
      </div>
    </div>
  );
};
